export default __webpack_public_path__ + "static/media/small.bf6f87ac.jpg";